import { render, staticRenderFns } from "./student-detail.vue?vue&type=template&id=0cdf80cc"
import script from "./student-detail.vue?vue&type=script&lang=js"
export * from "./student-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports